// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/get_vision_invite_by_token.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionInvitePublicView } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/get_vision_invite_by_token.proto.
 */
export const file_vision_membership_v1_get_vision_invite_by_token: GenFile = /*@__PURE__*/
  fileDesc("CjV2aXNpb24vbWVtYmVyc2hpcC92MS9nZXRfdmlzaW9uX2ludml0ZV9ieV90b2tlbi5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIosBCh1HZXRWaXNpb25JbnZpdGVCeVRva2VuUmVxdWVzdBJRCgZwYXJhbXMYASABKAsyQS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuR2V0VmlzaW9uSW52aXRlQnlUb2tlblJlcXVlc3QuUGFyYW1zGhcKBlBhcmFtcxINCgV0b2tlbhgBIAEoCSLDAQoeR2V0VmlzaW9uSW52aXRlQnlUb2tlblJlc3BvbnNlElIKBnJlc3VsdBgBIAEoCzJCLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5HZXRWaXNpb25JbnZpdGVCeVRva2VuUmVzcG9uc2UuUmVzdWx0Gk0KBlJlc3VsdBJDCgZpbnZpdGUYASABKAsyMy5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuVmlzaW9uSW52aXRlUHVibGljVmlld2IGcHJvdG8z", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.GetVisionInviteByTokenRequest
 */
export type GetVisionInviteByTokenRequest = Message<"protos.vision.membership.v1.GetVisionInviteByTokenRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.GetVisionInviteByTokenRequest.Params params = 1;
   */
  params?: GetVisionInviteByTokenRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.GetVisionInviteByTokenRequest.
 * Use `create(GetVisionInviteByTokenRequestSchema)` to create a new message.
 */
export const GetVisionInviteByTokenRequestSchema: GenMessage<GetVisionInviteByTokenRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_get_vision_invite_by_token, 0);

/**
 * @generated from message protos.vision.membership.v1.GetVisionInviteByTokenRequest.Params
 */
export type GetVisionInviteByTokenRequest_Params = Message<"protos.vision.membership.v1.GetVisionInviteByTokenRequest.Params"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message protos.vision.membership.v1.GetVisionInviteByTokenRequest.Params.
 * Use `create(GetVisionInviteByTokenRequest_ParamsSchema)` to create a new message.
 */
export const GetVisionInviteByTokenRequest_ParamsSchema: GenMessage<GetVisionInviteByTokenRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_get_vision_invite_by_token, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.GetVisionInviteByTokenResponse
 */
export type GetVisionInviteByTokenResponse = Message<"protos.vision.membership.v1.GetVisionInviteByTokenResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.GetVisionInviteByTokenResponse.Result result = 1;
   */
  result?: GetVisionInviteByTokenResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.GetVisionInviteByTokenResponse.
 * Use `create(GetVisionInviteByTokenResponseSchema)` to create a new message.
 */
export const GetVisionInviteByTokenResponseSchema: GenMessage<GetVisionInviteByTokenResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_get_vision_invite_by_token, 1);

/**
 * @generated from message protos.vision.membership.v1.GetVisionInviteByTokenResponse.Result
 */
export type GetVisionInviteByTokenResponse_Result = Message<"protos.vision.membership.v1.GetVisionInviteByTokenResponse.Result"> & {
  /**
   * @generated from field: protos.vision.membership.v1.VisionInvitePublicView invite = 1;
   */
  invite?: VisionInvitePublicView | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.GetVisionInviteByTokenResponse.Result.
 * Use `create(GetVisionInviteByTokenResponse_ResultSchema)` to create a new message.
 */
export const GetVisionInviteByTokenResponse_ResultSchema: GenMessage<GetVisionInviteByTokenResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_get_vision_invite_by_token, 1, 0);

